import {StatusItemStatus} from '@netx/core-next/store/StatusItem';
// This pattern only matches strings that do NOT contain illegal chars for category names
export const invalidCharsPattern = /[~—|+<>:?*\\\/]/g;
export const invalidPeriodsPattern = /^(?!\.)(?!.*\.$)(?!.*?\.\.)/;
// This string is the human-readable translation of the above string, for explanatory messages:
export const invalidNameCharacters = '/ \\ . + " : * | < > ?';

export const CHUNK_SIZE_DEFAULT = 20 * 1000 * 1000; // 20MB
export const UNCHUNKED_MAX_FILE_SIZE_DEFAULT = 100 * 1000 * 1000; // 100MB

export enum UploadPref {
	UNCHUNKED_MAX_FILE_SIZE = 'sys.httpRequestLimit',
	CHUNK_SIZE = 'sys.uploadChunkSize',
}

export const UploadStatusItemStatus = {
	...StatusItemStatus,
	RECOVERED: 'recovered',
	UPLOADING: 'uploading',
} as const;

export type UploadStatusItemStatus =
	typeof UploadStatusItemStatus[keyof typeof UploadStatusItemStatus];
